export const TENGE_LABEL = '₸';
export const PHONE_LENGTH = 11;
export const IIN_NUMBER_LENGTH = 12;
export const PATTERN_MASK_CHAR = '_';
export const CONTACT_EMAIL = 'stasyugay@mediators.kz';
export const CONTACT_PHONE = '+77477946515';
export const CONTACT_PHONE_FORMATTED = '+7 747 794 65 15';
